export default "__VITE_ASSET__DS7wHLUH__"